const Prefix = `[View Users]`;
export const TrackingEvent = {
  ProfileTabChange: `${Prefix} User profile Tab Change`,
  ViewUserDetail: `${Prefix} View user details`,
  CreateCohort: `${Prefix} Create cohort button`,
  SaveCohort: `${Prefix} Save cohort`,
  ExportCSV: `${Prefix} Export CSV`,
  ExpandUsers: `${Prefix} Expand in Users Page`,
  ExpandProfile: `${Prefix} Expand in Profile Page`,
};
